import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../features/auth/authContext.js';

export const RequireAdmin: React.FC = () => {
  const auth = useAuth();

  if (auth.isLoading) {
    return (
      <main className="auth-state-screen" aria-busy="true">
        Verifying administrator access…
      </main>
    );
  }
  if (!auth.currentUser) return <Navigate to="/login" replace />;
  if (!auth.isAdmin) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
};
